// extracted by mini-css-extract-plugin
export default {"container":"container-XOrHR","prefix":"prefix-pq1rc","suffix":"suffix-aVUlx"};